import AOS from "aos";
import { useEffect, useState } from "react";
import { getJobs } from "../http";
import { NavLink } from 'react-router-dom'


const GrievanceMatrix = () => {

  const [jobs, setJobs] = useState([]);
  const [total, setTotal] = useState(0);
  const [category, setCategory] = useState('');
  const [page, setPage] = useState(1)

 // ✅ PDF Mapping
  // const pdfMap = {
  //   English: "/pdfs/grievance-english.pdf",
  //   Telugu: "/pdfs/grievance-telugu.pdf",
  //   Tamil: "/pdfs/grievance-tamil.pdf",
  //   Kannada: "/pdfs/grievance-kannada.pdf",
  //   Hindi: "/pdfs/grievance-english.pdf",
  //   Gujarati: "/pdfs/grievance-gujarati.pdf"
  // };
  //const BASE_URL = "http://localhost:4012"; 
  const BASE_URL = "https://kanakadurgafinance.com"; 

  const pdfMap = {
  //English: `${BASE_URL}/uploads/grievance/grievance-english.pdf`,
  Telugu: `${BASE_URL}/uploads/grievance/test.pdf`,
  Tamil: `${BASE_URL}/uploads/grievance/grievance-tamil.pdf`,
  Kannada: `${BASE_URL}/uploads/grievance/grievance-kannada.pdf`,
  Hindi: `${BASE_URL}/uploads/grievance/grievance-english.pdf`,
  Gujarati: `${BASE_URL}/uploads/grievance/grievance-gujarati.pdf`
};

  // ✅ Click handler
  const handleLanguageClick = (lang) => {
    const url = pdfMap[lang];
    if (url) {
      window.open(url, "_blank"); // open in new tab
    }
  };

  useEffect(() => {
    const fetchJob = async () => {
      try {
        const { data } = await getJobs(page, category);
        setJobs(data.jobs);
        setTotal(data.total)
      } catch (error) {
        console.log(error)
      }
    }
    fetchJob();
  }, [category, page])




  return (
    <>
      <section id="page-header">
        <div className="page-header-inner">
          <h1 className="page-header-main">Grievance Redressal Matrix</h1>
        </div>
      </section>

      <div className="container">
        <div className="heading" style={{ flexDirection: 'column' }}>
          <h1 style={{ textAlign: 'center' }} className="heading-primary">Grievance Redressal <span class="color-primary">Matrix</span></h1>
          <p className="text" style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>Escalation Matrix for Grievance Redressal
          </p>
        </div>

        {/* Language Tabs */}
        <div className="language-tabs">
          {["English", "Telugu", "Tamil", "Kannada", "Hindi", "Gujarati"].map((lang) => (
            // <button key={lang}>{lang}</button>
            <button key={lang} onClick={() => handleLanguageClick(lang)}>
              {lang}
            </button>
          ))}
        </div>

        {/* Grievance Table */}
        <div className="grievance-container">
          <table className="grievance-table">
            <thead>
              <tr>
                <th>Level</th>
                <th>Description</th>
                <th>Details</th>
              </tr>
            </thead>

            <tbody>
              {/* Level 1 */}
              <tr>
                <td>Level-1</td>
                <td>Registration of Complaint</td>
                <td>
                  <p><strong>Name:</strong> Mrs. Vunnava Bhargavi</p>
                  <p><strong>Address:</strong> 54-9-23, 100 Feet Road, Auto Nagar, Vijayawada, Andhra Pradesh – 520007</p>
                  <p><strong>Email Id:</strong> helpdesk@kanakadurgafinance.com</p>
                  <p><strong>Contact:</strong> 1800 309 3090/0866 678 9901</p>
                </td>
              </tr>

              {/* Level 2 */}
              <tr>
                <td>Level-2</td>
                <td>First Level of Escalation</td>
                <td>
                  <p><strong>Name:</strong> Mrs. Bellamkonda. Padmaja</p>
                  <p><strong>Address:</strong> 54-9-23, 100 Feet Road, Auto Nagar, Vijayawada, Andhra Pradesh – 520007</p>
                  <p><strong>Email Id:</strong> accountsmanager@kanakadurgafinance.com</p>
                </td>
              </tr>

              {/* Level 3 */}
              <tr>
                <td>Level-3</td>
                <td>Principal Nodal Officer</td>
                <td>
                  <p><strong>Name:</strong> Gandhi Vadde</p>
                  <p><strong>Address:</strong> 54-9-23, 100 Feet Road, Auto Nagar, Vijayawada, Andhra Pradesh – 520007</p>
                  <p><strong>Email Id:</strong> pno@kanakadurgafinance.com</p>
                  <p><strong>Contact Number::</strong> 7331103104</p>
                </td>
              </tr>
            </tbody>
          </table>

          {/* Notes Section */}
          <div className="grievance-notes">
            <ol>
              <li>
                Customers can escalate their complaints directly to the RBI Ombudsman either through its grievance portal link
                ( <a
                  href="https://cms.rbi.org.in/cms/indexpage.html"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: '#071b40', textDecoration: 'underline' }}
                >
                  https://cms.rbi.org.in/cms/indexpage.html
                </a>) or to the below mentioned regional addresses of RBI if they do not receive a satisfactory
                response within 30 days of filing their complaint with the NBFC.
              </li>
              <li>
                Complaints can also be filed through the dedicated e-mail (
                <a
                  href="mailto:crpc@rbi.org.in"
                  style={{ color: '#071b40', textDecoration: 'underline' }}
                >
                  crpc@rbi.org.in
                </a>) or sent in physical mode to the ‘Centralized Receipt and Processing
                Centre’ set up at Reserve Bank of India, 4th Floor, Sector 17, Chandigarh - 160017 in the format.
              </li>
              <li>
                Complainant can also call on the Contact Centre with a toll-free number – 14448 from 8:00 AM to 10:00 PM (Monday through Saturday, except
                National Holidays)– is being Operationalized in Hindi, English and in ten regional languages to begin with and will be expanded to cover other Indian
                languages in due course.
              </li>
            </ol>
          </div>
        </div>
      </div>
    </>
  );





}

export default GrievanceMatrix;